'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactScroll = require('react-scroll');
var _reactRouter = require('react-router');
var _reduxForm = require('redux-form');
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);


var _containers = require('../../containers');
var _RealtorLandingContactForm = require('../../containers/RealtorLandingContactForm/RealtorLandingContactForm');var _RealtorLandingContactForm2 = _interopRequireDefault(_RealtorLandingContactForm);
var _packagesConfigs = require('../../containers/RealtorPackagesContainer/packagesConfigs');


var _ = require('..');
var _NavTabs = require('../StatefulTabs/NavTabs');var _NavTabs2 = _interopRequireDefault(_NavTabs);
var _LandingSliderPhoto = require('../LandingSliderPhoto/LandingSliderPhoto');var _LandingSliderPhoto2 = _interopRequireDefault(_LandingSliderPhoto);
var _LandingLogosCarousel = require('../LandingLogosCarousel/LandingLogosCarousel');var _LandingLogosCarousel2 = _interopRequireDefault(_LandingLogosCarousel);
var _ReviewSites = require('../ReviewSites/ReviewSites');var _ReviewSites2 = _interopRequireDefault(_ReviewSites);
var _RealtorPackagesWrapper = require('../RealtorPackagesWrapper/RealtorPackagesWrapper');var _RealtorPackagesWrapper2 = _interopRequireDefault(_RealtorPackagesWrapper);
var _ArticlesRead = require('../ArticlesRead/ArticlesRead');var _ArticlesRead2 = _interopRequireDefault(_ArticlesRead);
var _WhatsAppWidget = require('../WhatsAppWidget/WhatsAppWidget');var _WhatsAppWidget2 = _interopRequireDefault(_WhatsAppWidget);
var _LetterSubscriptionForm = require('../LetterSubscriptionForm/LetterSubscriptionForm');var _LetterSubscriptionForm2 = _interopRequireDefault(_LetterSubscriptionForm);


var _constants = require('../../constants');
var _scrollTo = require('../../utils/scrollTo');var _scrollTo2 = _interopRequireDefault(_scrollTo);
var _multiLanguageHeadTags = require('../../helpers/multiLanguageHeadTags');var _multiLanguageHeadTags2 = _interopRequireDefault(_multiLanguageHeadTags);


var _RealtorLanding = require('./RealtorLanding.scss');var styles = _interopRequireWildcard(_RealtorLanding);
var _realtorLanding = require('../../../static/icons/realtorLanding');var _realtorLanding2 = _interopRequireDefault(_realtorLanding);
var _heart = require('../../../static/images/heart.png');var _heart2 = _interopRequireDefault(_heart);
var _RealtorLanding2 = require('../../../static/images/RealtorLanding');var _RealtorLanding3 = _interopRequireDefault(_RealtorLanding2);
var _RealtorLandingContactFormModal = require('../../containers/RealtorLandingContactForm/RealtorLandingContactFormModal');var _RealtorLandingContactFormModal2 = _interopRequireDefault(_RealtorLandingContactFormModal);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Containers
// Components
// Helpers
// styles
_reactScroll.scroller.scrollTo = _scrollTo2.default.bind(_reactScroll.scroller);
var promo = ['autojump', 'highlight', 'top'];
var manufacturer = [
{
  price: '400,000+',
  description: 'medium' },

{
  price: '1,000,000+',
  description: 'large' },

{
  price: '50,000+',
  description: 'small' }];var



RealtorLanding = function (_Component) {_inherits(RealtorLanding, _Component);
  function RealtorLanding(props) {_classCallCheck(this, RealtorLanding);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.












    getPackageMessage = function (packageInstance) {var
      translate = _this.props.packagesTranslate;
      var packageName = translate(packageInstance.packageNameKey).toString();
      var period = translate(packageInstance.currentPeriodKey).toString();
      var message = translate('defaultMessage').toString();

      return message.replace(/%plan%/, packageName).replace(/%period%/, period);
    };_this.

    scrollToForm = function () {return _this.scrollTo('realtor-landing-contact-us');};_this.
    scrollToPricing = function () {return _this.scrollTo('realtor-landing-pricing-block');};_this.
    handleClickСommunity = function () {return _this.scrollTo('realtor-landing-contact-us');};_this.

    scrollTo = function (name) {return _reactScroll.scroller.scrollTo(name, {
        duration: 500,
        offset: _this.props.isMobile ? -90 : -150,
        smooth: true });};_this.


    closeFormModal = function () {
      _this.setState({ isModalOpen: false, defaultPackageMessage: '' });
      _this.props.hideContactFormModal();
    };_this.

    handleChoosePackage = function (packageInstance) {
      var message = _this.getPackageMessage(packageInstance);
      _this.setState({ isModalOpen: true, defaultPackageMessage: message });
      _this.props.openContactFormModal();
    };_this.

    renderPromoItem = function (item) {return (
        _react2.default.createElement('div', { className: styles.featureItem, key: item },
          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.featureImage, styles.promoImage) }, _react2.default.createElement('img', { src: _realtorLanding2.default[item], alt: '' })),
          _react2.default.createElement('div', { className: styles.featureTitle }, _this.props.translate(item + 'Title')),
          _react2.default.createElement('div', { className: styles.featureDescription }, _this.props.translate(item + 'Description'))));};_this.



    renderManufacturerItem = function (item) {return (
        _react2.default.createElement('div', { className: styles.manufacturerItem, key: item.price },
          _react2.default.createElement('p', null, item.price),
          _react2.default.createElement('p', null, _this.props.translate('manufacturer', item.description))));};_this.state = { isModalOpen: false, defaultPackageMessage: '', formattedPackagePeriods: (0, _packagesConfigs.getFormattedRealtorPackagePeriods)(props.translate), isCalculator: false };return _this;}RealtorLanding.prototype.componentWillUnmount = function componentWillUnmount() {document.body.style.overflow = '';};RealtorLanding.prototype.



  render = function render() {var _props =
    this.props,route = _props.route,locale = _props.locale;
    var multiLanguage = (0, _multiLanguageHeadTags2.default)(route, locale);

    return (
      _react2.default.createElement('div', { className: styles.pageWrapper },
        _react2.default.createElement(_reactHelmet2.default, {
          titleTemplate: this.props.rootTranslate('title', 'titleTemplate')(),
          title: this.props.translate('pageTitleSeo')(),
          meta: [
          { property: 'og:url', content: '' + _constants.shareUrl + route },
          { property: 'og:title', content: this.props.translate('pageTitleSeo')() + ' | \u202BOnMap' },
          { property: 'og:description', content: this.props.translate('pageDescriptionSeo') },
          { name: 'description', content: this.props.translate('pageDescriptionSeo') }],

          link: [].concat(
          multiLanguage, [
          { rel: 'canonical', href: '' + _constants.shareUrl + route }]) }),


        _react2.default.createElement('div', { className: styles.aboutUsContainer },
          _react2.default.createElement('h1', { className: styles.aboutUsTitleMobile }, this.props.translate('pageTitle')),
          _react2.default.createElement('div', { className: styles.aboutUsImage },
            _react2.default.createElement('img', { src: _RealtorLanding3.default.aboutUsImage, alt: 'realtor' })),

          _react2.default.createElement('div', { className: styles.aboutUsContent },
            _react2.default.createElement('h1', { className: styles.aboutUsTitleDesktop }, this.props.translate('pageTitle')),
            _react2.default.createElement('p', null, this.props.translate('pageDescription')),
            _react2.default.createElement(_reactScroll.Link, {
                to: 'realtor-landing-contact-us',
                offset: this.props.isMobile ? -100 : -150,
                className: styles.link,
                smooth: true },

              _react2.default.createElement('p', null,
                this.props.translate('joinOnline'))))),




        _react2.default.createElement(_NavTabs2.default, {
          translate: this.props.translate }),

        _react2.default.createElement('div', { className: styles.aboutLeadsContainer },
          _react2.default.createElement('p', { className: styles.aboutLeadsTitleTablet },
            this.props.translate('aboutLeads', 'title')),

          _react2.default.createElement('img', { src: _RealtorLanding3.default.aboutLeads, alt: 'realtor' }),
          _react2.default.createElement('div', { className: styles.aboutLeadsText },
            _react2.default.createElement('p', { className: styles.aboutLeadsTitleDesktop },
              this.props.translate('aboutLeads', 'title')),

            _react2.default.createElement('p', null, this.props.translate('aboutLeads', 'foreword')),
            _react2.default.createElement('p', null, this.props.translate('aboutLeads', 'blockValue')))),


        _react2.default.createElement('div', { className: styles.carouselPhoto },
          _react2.default.createElement('div', { className: styles.title },
            _react2.default.createElement('p', null, this.props.translate('carouselPhoto', 'title'))),

          _react2.default.createElement(_LandingSliderPhoto2.default, { isMobile: this.props.isMobile, isRtl: this.props.isRtl })),

        _react2.default.createElement('div', { className: styles.promoContainer },
          _react2.default.createElement('div', { className: styles.promoWrapper },
            _react2.default.createElement('p', null, this.props.translate('promo', 'title')),
            _react2.default.createElement('div', { className: styles.promoItems }, promo.map(this.renderPromoItem))),

          _react2.default.createElement('p', { className: styles.reminder },
            this.props.translate('promo', 'reminder'))),


        _react2.default.createElement('div', { className: styles.manufacturerContainer },
          _react2.default.createElement('div', { className: styles.manufacturerWrapper },
            _react2.default.createElement('p', { className: styles.manufacturerTitle },
              this.props.translate('manufacturer', 'title')),

            _react2.default.createElement('div', { className: styles.manufacturerInfoWrapper },
              _react2.default.createElement('div', { className: styles.manufacturerItemWrapper },
                manufacturer.map(this.renderManufacturerItem))))),















        _react2.default.createElement('div', { className: styles.communityContainer },
          _react2.default.createElement('p', { className: styles.communityTitle },
            this.props.translate('community', 'title')),

          _react2.default.createElement('p', null,
            this.props.translate('community', 'foreword')),

          _react2.default.createElement('div', { className: styles.communitybuttonWrapper },
            _react2.default.createElement('img', { src: _heart2.default, className: styles.heart, alt: '' }),
            _react2.default.createElement('button', {
                onClick: this.handleClickСommunity },

              this.props.translate('community', 'buttonText'))),


          _react2.default.createElement(_LandingLogosCarousel2.default, null),
          _react2.default.createElement('p', null,
            this.props.translate('community', 'blockValue')),

          _react2.default.createElement('div', { className: styles.partnerLogo },
            _react2.default.createElement('img', { src: _RealtorLanding3.default.partnerLogo, alt: 'realtor' }))),


        _react2.default.createElement('div', { className: styles.testimonialsWrapper },
          _react2.default.createElement(_containers.FacebookTestimonialsContainer, null)),

        _react2.default.createElement('div', { className: styles.reviewSitesContainer },
          _react2.default.createElement(_ReviewSites2.default, {
            translate: this.props.translate })),


        !this.state.isModalOpen &&
        _react2.default.createElement('div', {
            className: styles.feedbackBlock,
            name: 'realtor-landing-contact-us' },

          _react2.default.createElement(_reactScroll.Element, null,
            _react2.default.createElement(_RealtorLandingContactForm2.default, null))),



        _react2.default.createElement('div', { className: styles.articlesReadWrapper },
          _react2.default.createElement(_ArticlesRead2.default, {
            translate: this.props.translate })),









        _react2.default.createElement(_.Modal, {
            className: 'contactUsModal',
            isOpen: this.state.isModalOpen,
            onRequestClose: this.closeFormModal,
            translate: this.props.translate,
            isRtl: this.props.isRtl,
            withoutTitle: true },

          _react2.default.createElement(_RealtorLandingContactFormModal2.default, {
            inModal: true,
            formModalIsOpen: this.state.isModalOpen,
            handleRequest: this.closeFormModal,
            initialValues: { message: this.state.defaultPackageMessage } })),


        _react2.default.createElement(_WhatsAppWidget2.default, null)));


  };return RealtorLanding;}(_react.Component);


RealtorLanding.propTypes = {
  translate: _propTypes2.default.func,
  rootTranslate: _propTypes2.default.func,
  packagesTranslate: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  openContactFormModal: _propTypes2.default.func,
  hideContactFormModal: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  route: _propTypes2.default.any };exports.default =


RealtorLanding;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorLanding/RealtorLanding.js
// module id = 2872
// module chunks = 0